/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UrlWithMirrors
 */
export interface UrlWithMirrors {
    /**
     * 
     * @type {string}
     * @memberof UrlWithMirrors
     */
    url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UrlWithMirrors
     */
    mirrors: Array<string>;
}

/**
 * Check if a given object implements the UrlWithMirrors interface.
 */
export function instanceOfUrlWithMirrors(value: object): value is UrlWithMirrors {
    let isInstance = true;
    isInstance = isInstance && "mirrors" in value && value["mirrors"] !== undefined;

    return isInstance;
}

export function UrlWithMirrorsFromJSON(json: any): UrlWithMirrors {
    return UrlWithMirrorsFromJSONTyped(json, false);
}

export function UrlWithMirrorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UrlWithMirrors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'mirrors': json['mirrors'],
    };
}

export function UrlWithMirrorsToJSON(value?: UrlWithMirrors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'mirrors': value.mirrors,
    };
}

